module.exports = __webpack_public_path__ + "static/media/img-veracruz.0e07e8ec.jpg";